<script>
    import FilterItemAddHeader from '@/components/page-filter-edit/filter-item-add/FilterItemAddHeader.vue';
    import FilterItemAddData from '@/components/page-filter-edit/filter-item-add/FilterItemAddData.vue';
    import FilterItemParentFilter from '@/components/page-filter-edit/FilterItemParentFilter.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_FILTER_ITEM_ADD}
        },
        components: {
            FilterItemAddHeader: FilterItemAddHeader,
            FilterItemAddData: FilterItemAddData,
            FilterItemParentFilter: FilterItemParentFilter,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <FilterItemAddHeader />
        <hr class="hr_light_98">
        <FilterItemAddData />
        <hr class="hr_light_98">
        <FilterItemParentFilter 
            :storeData="$store.getters.FILTER_ITEM_DATA_ADD"
        />
    </div>
</template>